import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { SettingsProvider } from "@/contexts/SettingsContext";
import { LandingPage } from "@/pages/LandingPage";
import { ArticlesPage } from "@/pages/ArticlesPage";
import { ArticleDetailPage } from "@/pages/ArticleDetailPage";
import { AdminLogin } from "@/pages/admin/AdminLogin";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import { AdminDashboard } from "@/pages/admin/AdminDashboard";
import { AdminOrders } from "@/pages/admin/AdminOrders";
import { AdminProducts } from "@/pages/admin/AdminProducts";
import { AdminBenefits } from "@/pages/admin/AdminBenefits";
import { AdminAbout } from "@/pages/admin/AdminAbout";
import { AdminGallery } from "@/pages/admin/AdminGallery";
import { AdminTestimonials } from "@/pages/admin/AdminTestimonials";
import { AdminLocationPartners } from "@/pages/admin/AdminLocationPartners";
import { AdminArticles } from "@/pages/admin/AdminArticles";
import { AdminSettings } from "@/pages/admin/AdminSettings";

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <div className="App grain bg-cream min-h-screen">
          <Toaster position="top-center" richColors />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/artikel" element={<ArticlesPage />} />
              <Route path="/artikel/:slug" element={<ArticleDetailPage />} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<AdminDashboard />} />
                <Route path="pesanan" element={<AdminOrders />} />
                <Route path="produk" element={<AdminProducts />} />
                <Route path="manfaat" element={<AdminBenefits />} />
                <Route path="tentang" element={<AdminAbout />} />
                <Route path="galeri" element={<AdminGallery />} />
                <Route path="testimoni" element={<AdminTestimonials />} />
                <Route path="lokasi-mitra" element={<AdminLocationPartners />} />
                <Route path="artikel" element={<AdminArticles />} />
                <Route path="pengaturan" element={<AdminSettings />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </div>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
